export default __webpack_public_path__ + "static/media/petit-gateau.6eb39987.webp";